import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_nav_bar = _resolveComponent("nav-bar")!
  const _component_hero_section = _resolveComponent("hero-section")!
  const _component_value_section = _resolveComponent("value-section")!
  const _component_brands_section = _resolveComponent("brands-section")!
  const _component_stats_section = _resolveComponent("stats-section")!
  const _component_promotion_section = _resolveComponent("promotion-section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_nav_bar),
    _createVNode(_component_hero_section),
    _createVNode(_component_value_section),
    _createVNode(_component_brands_section),
    _createVNode(_component_stats_section, { ref: "statsSectionRef" }, null, 512),
    _createVNode(_component_promotion_section)
  ]))
}